import { render } from "./BluePrint.vue?vue&type=template&id=f70bf4a4"
import script from "./BluePrint.vue?vue&type=script&lang=js"
export * from "./BluePrint.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__